import React from 'react';
import { Check } from 'lucide-react';

interface FeatureListProps {
  features: string[];
}

export const FeatureList: React.FC<FeatureListProps> = ({ features }) => {
  return (
    <ul className="space-y-2">
      {features.map((feature, index) => (
        <li key={index} className="flex items-center gap-2">
          <Check className="w-4 h-4 text-green-500" />
          <span className="text-gray-600">{feature}</span>
        </li>
      ))}
    </ul>
  );
}; 